import $ from "jquery";

export default (function () {

    var init = function () {

        $("body").on("click", ".js-disable-on-click", function (e) {
            var $button = $(this);
            var $form = $button.closest("form");
            if (!$form.valid()) {
                return;
            }

            e.preventDefault();
            disableSubmitButton($button);
            $form.submit();
        });

        var disableSubmitButton = function ($submitButton) {
            var message = $submitButton.data("submitting-message");
            $submitButton.val(message);
            $submitButton.addClass("app-submitting");
            $submitButton.prop("disabled", true);
        };
    };

    return {
        init: init
    };

})();

